import comp from "./AutomaticIBScaleTool";
export default comp;
